const p = (e) => e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
export {
  p as escapeRegExp
};
